var array = Array.prototype;

export var map = array.map;
export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-scale/src/array.js
// module id = ../../../../d3-scale/src/array.js
// module chunks = 3